import { mountSingleRace } from './utils/mount-single-race.js';
mountSingleRace('CA-8149').catch(console.error);
